export const PAGE_SIZE = 20;
export const BASE_URL = 'https://jsonplaceholder.typicode.com/';
export const CURRENCY_BASE_URL = 'https://api.collectapi.com/economy/';
export const CURRENCY_AUTH_TOKEN =
  'apikey 41V0Du6yv1EwqQGUSfkodF:3V99zHOE4P2KXqptk5DTJx';
